/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_Shipping_Charge_LabelInputs */

const en_new_shipping_charge_label = /** @type {(inputs: New_Shipping_Charge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New Shipping Charge ($)`)
};

const es_new_shipping_charge_label = /** @type {(inputs: New_Shipping_Charge_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuevo cargo de envio ($)`)
};

/**
* | output |
* | --- |
* | "New Shipping Charge ($)" |
*
* @param {New_Shipping_Charge_LabelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const new_shipping_charge_label = /** @type {((inputs?: New_Shipping_Charge_LabelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_Shipping_Charge_LabelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_new_shipping_charge_label(inputs)
	return es_new_shipping_charge_label(inputs)
});